import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { historyReset } from 'redux/historySlice';
import { stepReset } from 'redux/stepSlice';
import { schemaReset } from 'redux/schemaSlice';
import { keyFieldsReset } from 'redux/keyFieldsSlice';

import CalculationTabs from 'components/CalculationTabs';
import StepHelp from 'components/StepHelp';
import MetricsWizard from 'components/MetricsWizard';
import DataUtilitiesModal from 'components/DataUtilitiesModal';

import { StyledContentContainer, SidebarContainer } from './App-styled';

import { CalciteNavigation, CalciteNavigationLogo } from 'components/Calcite';

const App: React.FC = () => {
  const dispatch = useDispatch();

  const [modalOpen, setModalOpen] = useState(false);

  const onTitleClick = () => {
    dispatch(stepReset());
    dispatch(schemaReset());
    dispatch(keyFieldsReset());
    dispatch(historyReset());
  };

  return (
    <>
      <CalciteNavigation>
        <CalciteNavigationLogo
          slot="content-start"
          heading="ArcGIS Velocity Data Size Utility"
          onClick={onTitleClick}
        />
      </CalciteNavigation>
      <StyledContentContainer>
        <SidebarContainer>
          <CalculationTabs />
          <StepHelp openModal={() => setModalOpen(true)} />
        </SidebarContainer>
        <MetricsWizard />
      </StyledContentContainer>
      <DataUtilitiesModal
        onClose={() => setModalOpen(false)}
        open={modalOpen}
      />
    </>
  );
};

export default App;
